/*
 * Generation step hints: when one year sits in two overlapping fitment rows (RAM 1500 2025: "2025-2026" and
 * "2019-2026"), the bare year ranges do not tell a shopper which pattern is theirs. The rows' seat types do, so
 * each option gets a second line naming the seat row that differs: front seats first, then 2nd row, then 3rd row
 * (Dodge Durango 2015+: "2nd row: Captain Seats" vs "2nd row: Bench Seat / Bucket Seats"). No DOM here.
 * Loaded `defer` by blocks/product_vehicle-steps.liquid before seatfit-vehicle-steps-model.js.
 */
(function () {
  'use strict';
  if (window.SeatFitGenHints) return;
  var ROWS = [['front', 'Front'], ['rear', '2nd row'], ['third', '3rd row']];

  function seatTypes(option, key) {
    return ((option && option.sub && option.sub[key]) || []).map(function (x) {
      return x && typeof x === 'object' ? x.n : x;
    }).filter(Boolean).join(' / ');
  }

  // options = SeatFit's genOptions ({label, sub, sets, ...}) -> one hint per option ('' = none), in the same order.
  function forOptions(options) {
    if (!options || options.length < 2) return [];
    for (var i = 0; i < ROWS.length; i++) {
      var lists = options.map(function (o) { return seatTypes(o, ROWS[i][0]); });
      var distinct = lists.filter(function (v, j) { return lists.indexOf(v) === j; });
      if (distinct.length > 1 && lists.some(Boolean)) {
        var name = ROWS[i][1];
        return lists.map(function (v) { return v ? name + ': ' + v : ''; });
      }
    }
    return [];
  }

  window.SeatFitGenHints = { forOptions: forOptions };
})();
